exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paypal-button-label-container[data-v-6369ae90] {\n  padding: 10px 0;\n  background: #F2BA36;\n  border-radius: 0;\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n  text-decoration: none;\n  font-family: Arial, Helvetica, Verdana, sans-serif;\n  line-height: 21px;\n  width: 100% !important;\n  display: block;\n  border-radius: 25px;\n}\n.paypal-button-label-container img[data-v-6369ae90] {\n  height: 20px;\n}", ""]);

// exports
